import { render, staticRenderFns } from "./GestionBodegaDetalleCodigos.vue?vue&type=template&id=031cd71c&scoped=true"
import script from "./GestionBodegaDetalleCodigos.vue?vue&type=script&lang=js"
export * from "./GestionBodegaDetalleCodigos.vue?vue&type=script&lang=js"
import style0 from "./GestionBodegaDetalleCodigos.vue?vue&type=style&index=0&id=031cd71c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031cd71c",
  null
  
)

export default component.exports